/*eslint-disable*/
import React, { Component, useContext, useState } from 'react';
import { Context } from '../../AppContext';
import DayPickerCab from './DayPickerCab';
type DateRange = {
  from: Date;
  to: Date;
};
type DesktopCalendarProps = {
  isMobileDevice: boolean;
  saveDates: (DateRange) => void;
  selectedFromDate: Date;
  selectedToDate: Date | undefined;
  closeCheckinPopup: () => void;
  handleFocus: () => void;
  changeFocusState: (string) => void;
  inputName: string;
  numberOfMonths: number | undefined;
  fromMonth: Date | undefined;
};

const DesktopCalendar = ({
  isMobileDevice,
  selectedFromDate,
  selectedToDate,
  saveDates,
  closeCheckinPopup,
  handleFocus,
  changeFocusState,
  inputName,
  numberOfMonths,
  fromMonth
}: DesktopCalendarProps) => {
  const { trackTemplateEvent } = useContext(Context);
  const [from, setFrom] = useState(selectedFromDate);
  const [to, setTo] = useState(selectedToDate);
  const [open, setOpen] = useState(true);
  const [saveBtnFlag, setSaveBtnFlag] = useState(false);

  //Calendar From Date
  const updateFromDate = (from: Date, focusElem: string) => {
    setFrom(from);
    changeFocusState(focusElem);
    let toDate = new Date(from.getTime() + 1000 * 60 * 60 * 24);
    saveDates({ from: from, to: toDate });
    trackTemplateEvent(`Cab_SEO_Pickup_Date_Select`);
  };

  //Calendar To Date
  const updateToDate = (to: Date, focusElem, close: string) => {
    changeFocusState(focusElem);
    setTimeout(() => setTo(to), 0);
    // hack for updating the next date as per old MMT calendar
    if (!close) {
      setTimeout(() => overlayCalSave(from, to), 0);
    } else {
      setTimeout(() => saveDates({ from: from, to: to }), 0);
    }
    trackTemplateEvent(`Cab_SEO_Drop_Date_Select`);
  };
  const overlayCalClose = () => {};
  const overlayCalSave = (from: Date, to: Date | undefined) => {
    setFrom(from);
    setTo(to);
    saveDates({ from: from, to: to });
    setOpen(false);
    changeFocusState('pickUpTime');
    handleFocus();
  };

  return (
    <div className="hotelCalOverlay">
      <div className="dayPickerHotelWrap">
        <p className="calHeader">
          <span className="font18 latoBold blackText">
            {selectedToDate ? 'Select Pick-Up Date' : 'Select Drop Date'}
          </span>
          <span className="close" onClick={() => closeCheckinPopup()}></span>
        </p>
        <DayPickerCab
          isMobileDevice={isMobileDevice}
          updateFromDate={updateFromDate}
          selectedFromDate={selectedFromDate}
          selectedToDate={selectedToDate}
          updateToDate={updateToDate}
          closeCheckinPopup={closeCheckinPopup}
          overlayCalClose={overlayCalClose} //doubt
          handleFocus={handleFocus}
          inputName={inputName}
          numberOfMonths={numberOfMonths}
          fromMonth={fromMonth}
        />
        {saveBtnFlag && (
          <div className="hotelcalDoneBtn">
            <span
              onClick={() => overlayCalSave(from, to)}
              className="bluePrimarybtn doneBtn font14"
            >
              Save Changes
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DesktopCalendar;
